export enum TimeOfClickKeys {
  block = 'Block',
  warn = 'Warn',
  allow = 'Allow',
}

export enum TimeOfClickActionsEnum {
  block = 0,
  warn = 1,
  allow = 2,
}

export type TimeOfClickActions = 'Block' | 'Warn' | 'Allow';

export interface ExchangeInlineProtectionSettings {
  inlineProtectionSettings: {
    inboundRuleEnable: boolean;
    outboundRuleEnable: boolean;
  };
  senderAddressMatchSettings: {
    envelopeAddressEnable: boolean;
    messageAddressEnable: boolean;
  };
  trustScanEnable: boolean;
}

export interface OtherExchangeInlineProtectionSettings {
  envelopeAddressEnable: boolean;
  messageAddressEnable: boolean;
  trustScanEnable: boolean;
}

export interface GmailInlineProtectionSettings {
  senderAddressMatchSettings: {
    envelopeAddressEnable: boolean;
    messageAddressEnable: boolean;
  };
  trustScanEnable: boolean;
}

export interface OtherGmailInlineProtectionSettings {
  envelopeAddressEnable: boolean;
  messageAddressEnable: boolean;
  trustScanEnable: boolean;
}

export interface SenderAddressMatchSettings {
  envelopeAddressEnable: boolean;
  messageAddressEnable: boolean;
}

export enum ExchangeInlineProtectionSetting {
  inbound = 'inbound',
  outbound = 'outbound',
}

export interface GmailInlineProtectionInfo {
  inboundHostname: string;
  outboundHostname: string;
  outboundLoopHeader: string;
  inboundLoopHeader: string;
}
